import { create } from "zustand";

interface BtnObject {
  type: string;
  onClickFunction: Function | null;
  tooltip: {
    theme?: "white" | "blue";
    direction:
      | "left"
      | "top"
      | "top-left"
      | "top-right"
      | "bottom"
      | "bottom-left"
      | "bottom-right"
      | "right"
      | "right-top"
      | "right-bottom"
      | "left-top"
      | "left-bottom";
    label: string;
  };
  disabled?: boolean;
  isVisible?: boolean;
}

interface MoreMenuStyle {
  left: number;
  top: number;
  isReverse?: boolean;
}

interface MoreMenuStoreType {
  btnList: Array<BtnObject>;
  moreMenuStyle: MoreMenuStyle | null;
  isMoreMenuVisible: boolean;
  setBtnList: (value: Array<BtnObject>) => void;
  setMoreMenuStyle: (value: MoreMenuStyle) => void;
  setIsMoreMenuVisible: (value: boolean) => void;
}

const useMoreMenuStore = create<MoreMenuStoreType>((set) => ({
  btnList: [
    {
      type: "",
      onClickFunction: null,
      tooltip: { theme: "white", direction: "right", label: "" },
    },
  ],
  moreMenuStyle: null,
  isMoreMenuVisible: false,
  setBtnList: (value: Array<BtnObject>) => {
    set({ btnList: value });
  },
  setMoreMenuStyle: (value: MoreMenuStyle) => {
    set({ moreMenuStyle: value });
  },
  setIsMoreMenuVisible: (value: boolean) => {
    set({ isMoreMenuVisible: value });
  },
}));

export default useMoreMenuStore;
